import { Skeleton } from './Loader';

const DetailRow = ({ label, value, loading }) => (
  <div className="flex flex-wrap items-baseline justify-between gap-2 border-b border-theme-border py-3 last:border-0 dark:border-themedark-border">
    <span className="text-base text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">{label}</span>
    {loading ? (
      <Skeleton w="10rem" h="0.9rem" />
    ) : (
      <span className="text-base text-theme-headings dark:text-themedark-headings">{value || '—'}</span>
    )}
  </div>
);

export default DetailRow;
